var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "recommissionVehicleModal",
        size: "md",
        "content-class": "sub-menu-bg-blue-transparent rcv-modal",
        title: "Recommission Vehicle",
        "hide-footer": "",
        "no-fade": "",
        "header-close-variant": "light",
      },
    },
    [
      _vm.vehicle
        ? _c("div", { staticClass: "rcv-body" }, [
            _c(
              "div",
              { staticClass: "rcv-info-strip" },
              [
                _c("fa", {
                  staticClass: "rcv-info-icon",
                  attrs: { icon: ["fas", "check-circle"] },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("This will mark the vehicle as active again."),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "rcv-vehicle-card" }, [
              _c("div", { staticClass: "rcv-vehicle-row" }, [
                _c("span", { staticClass: "rcv-label" }, [_vm._v("Vehicle")]),
                _vm._v(" "),
                _c("span", { staticClass: "rcv-value" }, [
                  _vm._v(_vm._s(_vm.vehicle.vehicle_name)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rcv-vehicle-row" }, [
                _c("span", { staticClass: "rcv-label" }, [_vm._v("Region")]),
                _vm._v(" "),
                _c("span", { staticClass: "rcv-value" }, [
                  _vm._v(_vm._s(_vm.vehicle.region)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "rcv-confirm-text" }, [
              _vm._v("\n      Vehicle "),
              _c("b", { staticClass: "rcv-highlight" }, [
                _vm._v(_vm._s(_vm.vehicle.vehicle_name)),
              ]),
              _vm._v(" will be set back to\n      "),
              _c("b", { staticClass: "rcv-highlight rcv-highlight--success" }, [
                _vm._v("ACTIVE"),
              ]),
              _vm._v(
                ".\n      It will be moved back to the Active vehicles list.\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rcv-actions" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "rcv-confirm-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v("\n        Confirm Recommission\n      ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }